module.exports = __webpack_public_path__ + "static/media/Residential_08.0cf64cc6.jpg";